// Components
import ConnectOauth from '../common';
import { ConnectorType } from '@hum/icm-app/src/state';

export const ConnectXero = ConnectOauth(ConnectorType.Xero);
